/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_AssigneesInputs */

const en_prop_assignees = /** @type {(inputs: Prop_AssigneesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignees`)
};

const de_prop_assignees = /** @type {(inputs: Prop_AssigneesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuständige`)
};

/**
* | output |
* | --- |
* | "Assignees" |
*
* @param {Prop_AssigneesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_assignees = /** @type {((inputs?: Prop_AssigneesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_AssigneesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_assignees(inputs)
	return en_prop_assignees(inputs)
});